<template>
  <div>
    <detailsForm
      v-if="okParameters && client"
      :timeZones="timeZones"
      :cultures="cultures"
      :status="status"
      :rgpd="rgpd"
      :apiCurves="apiCurves"
      :availableServices="availableServices"
      :client="client"
      :businessActs="businessActs"
      :key="client.externalId"
    />

    <div class="content">
      <div class="row">
        <div class="col-md-12" style="text-align: right">
          <button class="dm-a-default" @click="goToList">
            <i class="scf-arrow-left"></i> {{ $t("pages.Client.returnToList") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import ClientService from "../../services/ClientService";
import detailsForm from "../../forms/DetailsForm";

export default defineComponent({
  name: "details",
  inject: ["accessToken"],
  components: {
    detailsForm,
  },
  watch: {
    currentScope(newVal) {
        if (newVal) {
          this.clientService = new ClientService(this.$jwt.token, newVal);
        }
      },
      accessToken(newVal) {
        if (newVal) {
          this.clientService = new ClientService(newVal, this.currentScope);
        }
      },
      "$i18n.locale": {
        handler() {
          this.businessActs = this.prepareBusinessActs(this.businessActs);
        }
      },
  },
  props: {
    client: {
      type: Object,
      required: true,
    },
  },
  data() {
  return {
    businessActs: [],
    timeZones: [],
    cultures: [],
    apiCurves: [],
    availableServices: [],
    okParameters: false,
  };
},
computed: {
  culture() {
    return this.$i18n.locale;
  },
  status() {
    return this.clientService.getStatus();
  },
  rgpd() {
    return this.clientService.getRGPD();
  }
},
created() {
  this.clientService = new ClientService(this.$jwt.token, this.$jwt.scope);
  this.currentScope = this.$jwt.scope;
}
,

  mounted() {
    var parameters = this.clientService
      .getParameters()
      .then((responseParams) => {
        this.apiCurves = responseParams.clientApiCurves;
        this.timeZones = responseParams.timezones;
        this.cultures = responseParams.clientCultures;
        this.availableServices = responseParams.clientServices;
        this.businessActs = this.prepareBusinessActs(responseParams.businessActs);
        this.okParameters = true;
      })
      .catch((error) => {
        console.log(error);
      });
    console.log(parameters);
  },

  methods: {
    
    goToList: function () {
      this.$emit("closeDetails");
    },
    prepareBusinessActs(businessActs) {
      if (Array.isArray(businessActs))
        return businessActs.map((ba) => { ba.display = this.$t(`businessActs.${ba.trKey}`); return ba; })
      let transformedBusinessActs = [];
      Object.keys(businessActs).forEach((k) => {
        const item = {
          trKey: k,
          businessAct: businessActs[k],
          display: this.$t(`businessActs.${k}`),
        }
        transformedBusinessActs.push(item);
      });
      return transformedBusinessActs;
    },
  },
});
</script>

<style scoped src="../../assets/css/client.css"></style>
